"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _noty = babelHelpers.interopRequireDefault(require("noty"));

var _node = babelHelpers.interopRequireDefault(require("./node"));

var _Discussion = require("../Discussion");

var _PromiseRenderer = babelHelpers.interopRequireDefault(require("PromiseRenderer"));

var _NodeTarget = require("NodeTarget");

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp, _dec, _class3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _temp2;

var AcceptBody = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(AcceptBody, _Component);

  function AcceptBody() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, AcceptBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(AcceptBody)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "node", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "children", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "parent", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(AcceptBody, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "comment"
      }, _react.default.createElement("div", {
        className: "alert alert-success"
      }, this.parent.child_type == 'eventScheduleResponse' ? 'The event schedule was accepted ' : 'This assignment has been accepted ', "at ", new Date(this.node.created).format('F j, Y g:i A'), " by ", this.node.account.fullName, "."), this.props.children ? _react.default.createElement("div", {
        style: {
          whiteSpace: 'pre-line'
        },
        className: "comment-text"
      }, this.props.children) : null);
    }
  }]);
  return AcceptBody;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "parent", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
var AcceptNode = (_dec = (0, _decorators.alias)("state.userProfile"), (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(AcceptNode, _Component2);

  function AcceptNode() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, AcceptNode);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(AcceptNode)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "node", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "discussion", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "commentPosted", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "Element", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "trackData", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "userProfile", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2.state = {
      theNode: _this2.discussion.getNode(_this2.node.node.parent),
      userProfile: null
    };
    return _this2;
  }

  babelHelpers.createClass(AcceptNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      $(document).on('profileUpdated', this.profileUpdatedEvent);
      (0, _userProfile.getUserProfile)().then(this.profileUpdated);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(document).off('profileUpdated', this.profileUpdatedEvent);
    }
  }, {
    key: "profileUpdatedEvent",
    value: function profileUpdatedEvent(event) {
      this.profileUpdated(event.profile);
    }
  }, {
    key: "profileUpdated",
    value: function profileUpdated(profile) {
      this.setState({
        userProfile: profile
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.node) {
        return _react.default.createElement(_PromiseRenderer.default, {
          promise: this.state.theNode,
          success: this.renderWithResult
        });
      }

      return null;
    }
  }, {
    key: "renderWithResult",
    value: function renderWithResult(body) {
      var _this3 = this;

      var Element = this.Element;
      return _react.default.createElement(_NodeTarget.Root, {
        rootFor: "accept"
      }, function (Target, Element2) {
        return _react.default.createElement("div", null, _react.default.createElement(_node.default, {
          discussion: _this3.discussion,
          node: _this3.node.node,
          footer: null
        }, _react.default.createElement(AcceptBody, {
          node: _this3.node.node,
          parent: body
        }, _this3.node.node.comment)), _this3.node.node.permissions.reply && _react.default.createElement(Element, null, _react.default.createElement(Target, null, _react.default.createElement("section", {
          className: "child-comments open"
        }, _react.default.createElement("div", {
          className: "sub-comment-list"
        }, _this3.node.children.length ? _this3.node.children.map(function (child) {
          return _react.default.createElement(_Discussion.DiscussionNode, {
            Element: Element2,
            discussion: _this3.discussion,
            trackData: _this3.trackData,
            key: child.node.id,
            commentPosted: _this3.commentPosted,
            node: child
          });
        }) : null), _react.default.createElement("div", {
          className: "comment-form"
        }, _this3.userProfile ? _react.default.createElement("form", {
          method: "post",
          onSubmit: function onSubmit() {
            return false;
          }
        }, _react.default.createElement("div", {
          className: "photo"
        }, _react.default.createElement(_ProfileImageContainer.default, {
          className: "userProfilePhoto",
          noImageClassName: "initials default",
          image: _this3.userProfile.photo,
          name: _this3.userProfile.nickname || _this3.userProfile.fullName || ""
        })), _react.default.createElement("div", {
          className: "comment"
        }, _react.default.createElement("div", {
          className: "comment-field"
        }, "Stuff goes here"))) : null)))));
      });
    }
  }]);
  return AcceptNode;
}(_react.Component), _temp2), (_descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "Element", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "userProfile", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "profileUpdatedEvent", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "profileUpdatedEvent"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "profileUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "profileUpdated"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "renderWithResult", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "renderWithResult"), _class3.prototype)), _class3));
exports.default = AcceptNode;